import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchSubChannelDetail = createAsyncThunk("fetchSubChannelDetail", async ({ channel_id, id }) => {
	const response = await axiosHttp.get(`channel/${channel_id}/sub_channel/${id}`);
	return response.data.data;
});

const SubChannelDetailsSlice = createSlice({
	name: "SubChannelDetailsSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchSubChannelDetail.pending, (state) => {
			state.isLoading = true;
		});
		builder.addCase(fetchSubChannelDetail.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchSubChannelDetail.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default SubChannelDetailsSlice.reducer;
